import styled from "styled-components";
import {
	COLOR_RED,
	MOBILE_L_BP,
	TABLET_M_BP,
	COLOR_SKY_BLUE,
} from "@website-builder/utilities-index";

export const VideoModalWrapper = styled.div`
	.modalWrapper {
		background-color: ${COLOR_SKY_BLUE};
		padding: 40px;
		border: none;
	}
	.closeButtonWrapper .closeButton {
		width: 15px;
		position: absolute;
		right: 55px;
		top: 25px;
	}
	.modalBodyCustom {
		width: 700px;
		.videoContainerCustom {
			height: 400px;
			width: 700px !important;
		}
	}
	.modalContainer {
		div {
			div {
				background-color: ${COLOR_RED} !important;
			}
		}
	}
	.closeButtonWrapper {
		text-align: right;
		position: absolute;
		right: -50px !important;
		top: -20px !important;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.modalWrapper {
			padding: 35px;
		}
		.modalBodyCustom {
			max-width: 500px;
			.videoContainerCustom {
				max-width: 500px !important;
				max-height: 280px;
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.modalWrapper {
			padding: 20px;
		}
		.closeButtonWrapper .closeButton {
			width: 10px;
			right: 5px;
		}
		.modalBodyCustom {
			max-width: 280px;
			.videoContainerCustom {
				max-width: 280px !important;
				max-height: 180px;
			}
		}
		.closeButtonWrapper {
			right: 0px !important;
		}
	}
`;
